import { Epic, ofType } from "redux-observable";
import { ZohoActions } from "../actions";
import { Observable } from "rxjs";
import {
    ZOHO_PHASE_FILE,
    ZOHO_PHASE_EXTRA_FILE,
    ZOHO_PHASE_FOUR,
    ZOHO_PHASE_ONE,
    ZOHO_PHASE_THREE,
    ZOHO_PHASE_TWO,
} from "../constants";
import { exhaustMap } from "rxjs/operators";
import { ZohoRepository } from "../../../repositories/zoho.repository";
import {
    ZohoPhaseFile,
    ZohoPhaseFileExtra,
    ZohoPhaseFour,
    ZohoPhaseOne,
    ZohoPhaseThree,
    ZohoPhaseTwo,
} from "../actions/default";
import { RootState } from "../../reducers";
import { TypeRates } from "../../../constants/enums/quotation";
import { GetChannelZohoPhaseOne } from "../../../libs/channels/core/channels";

export const zohoPhaseOneEpic: Epic<ZohoActions, ZohoActions, RootState> = (
    action$: Observable<ZohoActions>,
    state$
) =>
    action$.pipe(
        ofType(ZOHO_PHASE_ONE),
        exhaustMap((action) => {
            const {
                customer: {
                    business: { ruc, payrollMonthlyAmount },
                    contact: { name, phone, email },
                },
                quotation: {
                    workersRange,
                    annual: { totalPrime: annualPrice },
                    semester: { totalPrime: semesterPrice },
                },
                page: {
                    channels: { channel },
                },
            } = state$.value;
            action.payload = {
                ruc,
                lastName: name,
                phone,
                email,
                amount: payrollMonthlyAmount,
                range: workersRange,
                annualPrice,
                semesterPrice,
                from: window.location.search,
                channel: GetChannelZohoPhaseOne(channel),
            };
            return ZohoRepository.saveZohoPhaseOne(
                action as ZohoPhaseOne,
                state$.value
            );
        })
    );

export const zohoPhaseTwoEpic: Epic<ZohoActions, ZohoActions, RootState> = (
    action$: Observable<ZohoActions>,
    state$
) =>
    action$.pipe(
        ofType(ZOHO_PHASE_TWO),
        exhaustMap((action) => {
            const {
                zoho: { zohoId },
                quotation: {
                    calculated: {
                        [TypeRates.ANNUAL]: { annualPremium: annualPrice },
                        [TypeRates.SEMESTER]: {
                            biannualPremium: semesterPrice,
                        },
                    },
                },
            } = state$.value;
            action.payload = {
                annualPrice,
                semesterPrice,
                zohoId,
            };
            return ZohoRepository.saveZohoPhaseTwo(
                action as ZohoPhaseTwo,
                state$.value
            );
        })
    );

export const zohoPhaseThreeEpic: Epic<ZohoActions, ZohoActions, RootState> = (
    action$: Observable<ZohoActions>,
    state$
) =>
    action$.pipe(
        ofType(ZOHO_PHASE_THREE),

        exhaustMap((action) => {
            const {
                zoho: { zohoId },
                quotation: {
                    calculated: {
                        [TypeRates.ANNUAL]: { annualPremium: annualPrice },
                        [TypeRates.SEMESTER]: {
                            biannualPremium: semesterPrice,
                        },
                    },
                    initialMonth,
                    primeSelected,
                },
                payroll_file: { totalNumberOfWorkers, totalAmountOfSalary },
                legalRepresentativePopup: {
                    legalRepresentative: {
                        documentNumber,
                        name,
                        firstSurname,
                        lastSurname,
                        position,
                    },
                },
            } = state$.value;
            const initialMonthTransform = initialMonth.split("/");
            action.payload = {
                initialDate: `${initialMonthTransform[1]}-${initialMonthTransform[0]}-01T00:00:00`,
                typeRate:
                    primeSelected === TypeRates.ANNUAL ? "Anual" : "Semestral",
                amount:
                    primeSelected === TypeRates.ANNUAL
                        ? annualPrice
                        : semesterPrice,
                monthlyAmount: totalAmountOfSalary,
                employeeNumber: totalNumberOfWorkers,
                dni: documentNumber,
                name,
                lastName: `${firstSurname} ${lastSurname}`.trim(),
                position,
                zohoId,
            };
            return ZohoRepository.saveZohoPhaseThree(
                action as ZohoPhaseThree,
                state$.value
            );
        })
    );

export const zohoPhaseFourEpic: Epic<ZohoActions, ZohoActions, RootState> = (
    action$: Observable<ZohoActions>,
    state$
) =>
    action$.pipe(
        ofType(ZOHO_PHASE_FOUR),

        exhaustMap((action) => {
            const {
                zoho: { zohoId },
            } = state$.value;
            action.payload = {
                zohoId,
            };
            return ZohoRepository.saveZohoPhaseFour(
                action as ZohoPhaseFour,
                state$.value
            );
        })
    );

export const zohoPhaseFileEpic: Epic<ZohoActions, ZohoActions, RootState> = (
    action$: Observable<ZohoActions>,
    state$
) =>
    action$.pipe(
        ofType(ZOHO_PHASE_FILE),

        exhaustMap((action) => {
            const {
                zoho: { zohoId },
            } = state$.value;
            action.payload = {
                ...action.payload,
                zohoId,
            };
            return ZohoRepository.saveZohoPhaseFile(
                action as ZohoPhaseFile,
                state$.value
            );
        })
    );
export const zohoPhaseFileExtraEpic: Epic<
    ZohoActions,
    ZohoActions,
    RootState
> = (action$: Observable<ZohoActions>, state$) =>
    action$.pipe(
        ofType(ZOHO_PHASE_EXTRA_FILE),
        exhaustMap((action) => {
            const {
                zoho: { zohoId },
            } = state$.value;
            action.payload = {
                zohoId,
            };
            return ZohoRepository.saveZohoPhaseFileExtra(
                action as ZohoPhaseFileExtra,
                state$.value
            );
        })
    );
